export const selectAllSlides = (state) => state.mainReducer.slides;
